import { Stack, Typography } from '@mui/material';
import type { BaseModalProps } from '@/interfaces/component/modal.interface';
import BaseModal from '@/components/modal/BaseModal';

export type GoogleMapCrawlingRequestStatus = 'HAS_REVIEW' | 'NO_REVIEW' | 'PROGRESS_NOT_END' | 'FAIL';

const GoogleCrawlingStatusModalChild = ({ textList }: { textList: string[] }) => {
  return (
    <Stack direction={'column'} gap={2}>
      {textList.map((text, i) => (
        <Typography key={i} sx={{ fontSize: '14px' }}>
          {text}
        </Typography>
      ))}
    </Stack>
  );
};

const GoogleCrawlingStatusModalProps: Record<GoogleMapCrawlingRequestStatus, Partial<BaseModalProps>> = {
  HAS_REVIEW: {
    modalTitle: '구글맵 리뷰 추가',
    children: (
      <GoogleCrawlingStatusModalChild
        textList={[
          '축하합니다!',
          '이제 구글맵에서 병원의 첫 번째 리뷰가 수집되었습니다. 리뷰 내용은 리뷰 관리 페이지에서 바로 확인하실 수 있습니다.',
          '계속해서 병원의 온라인 평판을 효과적으로 관리할 수 있도록 리뷰 수집은 자동으로 진행됩니다.'
        ]}
      />
    ),
    closeButtonTitle: '확인'
  },
  NO_REVIEW: {
    modalTitle: '구글맵 리뷰가 없습니다',
    children: (
      <GoogleCrawlingStatusModalChild
        textList={[
          '현재 구글맵에 등록된 리뷰가 없어 추가된 리뷰는 없습니다.',
          '앞으로 구글맵에 새로운 리뷰가 작성되면 자동으로 수집되어 서비스에서 확인하실 수 있습니다.',
          '병원의 온라인 평판 관리에 도움을 드릴 수 있도록 계속 모니터링하겠습니다.'
        ]}
      />
    ),
    closeButtonTitle: '확인'
  },
  PROGRESS_NOT_END: {
    modalTitle: '구글맵 리뷰 수집 실패',
    children: (
      <GoogleCrawlingStatusModalChild
        textList={[
          '구글맵 리뷰 수집 중 문제가 발생하여 수집에 실패하였습니다.',
          '문제를 해결하려면 리걸케어 카카오톡 채널로 문의해 주시기 바랍니다.',
          '최대한 빠르게 해결해드릴 수 있도록 지원하겠습니다.'
        ]}
      />
    ),
    closeButtonTitle: '확인'
  },
  FAIL: {
    modalTitle: '구글맵 리뷰 수집 실패',
    children: (
      <GoogleCrawlingStatusModalChild
        textList={[
          '구글맵 리뷰 수집 중 문제가 발생하여 수집에 실패하였습니다.',
          '문제를 해결하려면 리걸케어 카카오톡 채널로 문의해 주시기 바랍니다.',
          '최대한 빠르게 해결해드릴 수 있도록 지원하겠습니다.'
        ]}
      />
    ),
    closeButtonTitle: '확인'
  }
};

const GoogleChannelRequestStatusModal = ({
  showModal,
  handleShowModal,
  onCloseModal,
  status
}: {
  showModal: boolean;
  handleShowModal: () => void;
  onCloseModal: () => void;
  status: GoogleMapCrawlingRequestStatus;
}) => {
  return <BaseModal showModal={showModal} handleShowModal={handleShowModal} onCloseModal={onCloseModal} {...GoogleCrawlingStatusModalProps[status]} />;
};

export default GoogleChannelRequestStatusModal;
